import axios from 'axios';
import lottie from "lottie-web";
import React, { useState, useEffect, useRef } from 'react';

const Searchbox = React.forwardRef((props, ref) => {
    const containerPlan = useRef(null);
    let animation = null;
    useEffect(() => {
        // Load the animation
        const animation = lottie.loadAnimation({
            container: containerPlan.current,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '/animation/planed.json', // <-- must be .json for lottie-web
        });

        // Cleanup on unmount
        return () => animation.destroy();
    }, []);

    return (
        <div className="svg-animation-loader" ref={containerPlan} style={{ width: "400px", height: "400px" }} />
    )
});

export default Searchbox;